import React, { useEffect } from 'react';
import './ProjectWizardPage.scss';
import { useAccount } from '../../../shared/contexts/account/AccountContexts';
import DomainStep from './components/domain-step/DomainStep';
import SecondStep from './components/second-step/SecondStep';
import { useProjectWizard } from './contexts/ProjectWizardContext';
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate } from 'react-router-dom';
import { PROJECTS } from '../../../shared/routes/path';
import Loader from '../../../shared/components/common/loader/Loader';
import FirmNameStep from './components/firm-name-step/FirmNameStep';
import useRedirectWhenInvalidStatus from '../../../shared/hooks/account/UseRedirectWhenInvalidStatus';
import ThirdStep from './components/third-step/ThirdStep';
import useCanAddProject from '../../../shared/hooks/account/UseAddProject';

const ProjectWizardPage: React.FC = () => {
  const { t } = useTranslation();
  const { accountResponse } = useAccount();
  const { canAddProject, loading } = useCanAddProject();

  const navigation = useNavigate();
  const { activeStep } = useProjectWizard();

  useRedirectWhenInvalidStatus();

  useEffect(() => {
    if (!loading && canAddProject === false) {
      navigation(PROJECTS);
    }
  }, [loading, canAddProject, navigation]);

  return (
    <div className="project-wizard">
      <div
        className={`${
          activeStep === 'QUESTIONS' ? 'project-wizard__page--second' : ''
        } project-wizard__page`}
      >
        <main>
          <>
            <div className="project-wizard__belt">
              <div className="logo">
                <div className="logo-box" />
              </div>
              {accountResponse && (
                <NavLink to={PROJECTS} className="btn-link">
                  <span className="material-symbols-outlined">arrow_back_ios</span>
                  {t('backToProjects')}
                </NavLink>
              )}
            </div>
          </>
        </main>
        {loading ? (
          <div className="project-wizard__content">
            <div className="page-content">
              <Loader />
            </div>
          </div>
        ) : (
          <>
            <div className="project-wizard__content">
              {activeStep === 'DOMAIN' && <DomainStep />}
              {activeStep === 'FIRM_NAME' && <FirmNameStep />}
              {activeStep === 'QUESTIONS' && <SecondStep />}
              {activeStep === 'SEARCH_VOLUME' && <ThirdStep />}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ProjectWizardPage;
